export const data = [
  {
    section: "1-Start",
    title: "Start",
    back: 0,
  },
  {
    section: "2-Connectivity_B",
    title: "Connecting to the Energy Valve",
    back: 0,
  },
  {
    section: "2p1-Source_control",
    title: "Control Source",
    back: 1,
  },
  {
    section: "3-Know_the_flow",
    yes: 4,
    no: 8,
    title: "Do you know the design flow rate?",
    questions: {
      yes: "Yes",
      no: "No",
    },
    back: 2,
  },
  {
    section: "4-Flow_Control",
    title: "Flow Control",
    back: 3,
  },
  {
    section: "5-Flow-supply-water-temperatures",
    yes: 7,
    no: 6,
    maybe: 8,
    title:
      "Is the building running off fixed or varying flow temperatures?",
    questions: {
      yes: "Varying flow temperatures (Delta T Manager Scaling)",
      no: "Fixed flow temperatures (Delta T Manager)",
      maybe: "I am not sure",
    },
    back: 4,
  },
  {
    section: "6-Delta-T-Manager",
    title: "Delta T Manager",
    next: 18,
    back: 5,
  },
  {
    section: "7-Scaling",
    title: "Scaling",
    next: 18,
    back: 5,
  },
  {
    section: "8-Power-output",
    yes: 9,
    no: 10,
    title: "Do you know the power output?",
    questions: {
      yes: "Yes (Power Control)",
      no: "No (Position Control)",
    },
    back: [3, 5],
  },
  // Next is not working
  {
    section: "9-Power-Control_01",
    next: 11,
    title: "Power Control",
    back: 8,
  },
  {
    section: "10-Position-Control",
    next: 11,
    title: "Position Control",
    back: 8,
  },
  {
    section: "11-Onboard-data-Analysis",
    title: "Onboard Data Analysis",
    back: 9,
  },
  {
    section: "12-Did-you-get-a-Clear-Results",
    yes: 13,
    no: 16,
    title:
      "Did you get a clear result from the Energy Valve?",
    questions: {
      yes: "Yes",
      no: "No",
    },
    back: 11,
  },
  {
    section: "13-Flow-or-Power",
    flow: 14,
    power: 15,
    title: "How do you want to setup your Energy Valve?",
    questions: {
      flow: "Flow Control",
      power: "Power Control",
    },
    back: 12,
  },
  {
    section: "14-Flow-Control_02",
    next: 16,
    title: "Flow Control",
    back: 13,
  },
  {
    section: "15-Power-Control_02",
    next: 16,
    title: "Power Control",
    back: 13,
  },
  {
    section: "16-Connect-to-the-cloud",
    yes: 17,
    no: 19,
    title: "Would you like to connect to the cloud?",
    questions: {
      yes: "Yes",
      no: "No",
    },
    back: [12, 14, 15],
  },
  {
    section: "17-Cloud-Connectivity",
    next: 20,
    title: "Cloud Connectivity",
    back: [18, 16],
  },
  {
    section: "18-Onboard-Diagnostic-Download-Data",
    next: 17,
    title: "Onboard Diagnostics / Download Data",
    back: [6, 7],
  },
  {
    section: "19-Download-data",
    next: 21,
    title: "Download Data",
    back: 16,
  },
  {
    section: "20-Send-optimation-eques",
    next: 21,
    title: "Send optimization request",
    back: 17,
  },
  {
    section: "21-End",
    title: "End",
    back: [20, 19],
  },
];
